export const PERMISSIONS_ADMIN = "PERMISSIONS_ADMIN";
export const CAN_SEE_DEVICE_LOGS = "CAN_SEE_DEVICE_LOGS";
export const CAN_SEE_RAW_DATA_DETAILS = "CAN_SEE_RAW_DATA_DETAILS";
export const CAN_UPDATE_DEVICE_STATUS_TYPES = "CAN_UPDATE_DEVICE_STATUS_TYPES";

export const RAW_DATA_KEYS_TO_HIDE = ["channel"];
